


import React from 'react';
import { Box, Card, CardContent, Typography, Button, Stack } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const DeliverySummary = ({ order, onBackToOrders }) => {
  return (
    <Box textAlign="center">
      <Card sx={{ maxWidth: 500, margin: '0 auto' }}>
        <CardContent sx={{ p: 4 }}>
          {/* Success Icon */}
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              bgcolor: '#28a745',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}
          >
            <CheckCircle sx={{ fontSize: 60, color: '#fff' }} />
          </Box>

          {/* Success Message */}
          <Typography variant="h4" fontWeight={600} color="#28a745" gutterBottom>
            Order #{order.orderId}
          </Typography>
          <Typography variant="h5" gutterBottom>
            Delivered Successfully!
          </Typography>

          {/* Order Details */}
          <Card sx={{ bgcolor: '#f8f9fa', my: 3, textAlign: 'left' }}>
            <CardContent>
              <Stack spacing={1}>
                <Box display="flex" justifyContent="space-between">
                  <Typography color="text.secondary">Customer:</Typography>
                  <Typography fontWeight={600}>{order.customerName}</Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between">
                  <Typography color="text.secondary">Amount:</Typography>
                  <Typography fontWeight={600}>₹{order.totalAmount}</Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between">
                  <Typography color="text.secondary">Payment:</Typography>
                  <Typography fontWeight={600}>
                    {order.paymentMethod?.toUpperCase() || 'N/A'}
                  </Typography>
                </Box>
                
                <Box display="flex" justifyContent="space-between">
                  <Typography color="text.secondary">Delivered At:</Typography>
                  <Typography fontWeight={600}>
                    {new Date().toLocaleTimeString('en-IN', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>

          {/* Action Button */}
          <Stack spacing={2}>
            <Button 
              variant="contained" 
              size="large" 
              fullWidth 
              onClick={onBackToOrders}
              sx={{
                bgcolor: '#006D77',
                '&:hover': { bgcolor: '#005561' }
              }}
            >
              BACK TO ORDERS
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DeliverySummary;